'use client'

import { useEffect } from 'react'

const gtmId = process.env.NEXT_PUBLIC_GTM_ID

export function DeferredTagManager() {
  useEffect(() => {
    if (!gtmId) {
      return
    }

    let didLoad = false

    const loadTagManager = () => {
      if (didLoad || document.getElementById('google-tag-manager')) {
        return
      }

      didLoad = true
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: 'gtm.js', 'gtm.start': Date.now() })

      const script = document.createElement('script')
      script.async = true
      script.id = 'google-tag-manager'
      script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`
      document.head.appendChild(script)
    }

    const eventOptions: AddEventListenerOptions = { once: true, passive: true }
    window.addEventListener('pointerdown', loadTagManager, eventOptions)
    window.addEventListener('keydown', loadTagManager, eventOptions)

    return () => {
      window.removeEventListener('pointerdown', loadTagManager)
      window.removeEventListener('keydown', loadTagManager)
    }
  }, [])

  return null
}
